import { fetchCreateProxyPool } from '@fd/common/api/createPool';
import { fetchGenerateProxies } from '@fd/common/api/fetchGenerateProxies';
import { Button } from '@fd/frontend/components/ui/Button';
import { useTariffByProxyType } from '@fd/frontend/hooks/useTariffByProxyType';
import { useTrafficGbAvailableByProxyType } from '@fd/frontend/hooks/useTrafficAvailableByProxyType';
import useProxyPoolCreationForm from '@fd/frontend/store/proxyPoolCreationFormStore';
import { useTransition } from 'react';
import { useNavigate } from 'react-router';

export default function CreateButton({ className }: { className?: string }) {
  const poolProps = useProxyPoolCreationForm();
  const tariff = useTariffByProxyType(poolProps.proxyType);
  const [isPending, startTransition] = useTransition();
  const navigate = useNavigate();
  const availableTrafficGb =
    useTrafficGbAvailableByProxyType(poolProps.proxyType) ?? 0;

  const handleCreate = () => {
    if (availableTrafficGb === 0) {
      navigate(`/proxies/buy?type=${poolProps.proxyType}`);
      return;
    }
    if (!tariff.meter_subscription_id) {
      throw Error('handleCreateProxyPool no subscription id found');
    }
    const body = {
      subscription_id: tariff.meter_subscription_id,
      countries_list: poolProps.country ? [poolProps.country.countryCode] : [],
      pool_name: poolProps.name,
      cities_list: poolProps.cities,
      rotation: poolProps.rotation,
      protocol: poolProps.protocol,
    };
    startTransition(async () => {
      const newPool = await fetchCreateProxyPool(body);
      const proxyPoolUrl = `/proxy-pool/${newPool.id}`;
      await fetchGenerateProxies(newPool.id, poolProps.quantity);
      poolProps.resetForm();
      navigate(proxyPoolUrl);
    });
  };

  return (
    <Button disabled={isPending} onClick={handleCreate} className={className}>
      {availableTrafficGb === 0
        ? 'Buy to create'
        : isPending
        ? 'Creating...'
        : 'Create proxy pool'}
    </Button>
  );
}
